interface Props {
  [key: string]: any
}

export default function ChangeButtonIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} fill="none" height="8" viewBox="0 0 9 8" width="9">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M5.10856 1.09051L5.44768 0.7514C5.71744 0.481632 6.08333 0.330078 6.46484 0.330078C6.84635 0.330078 7.21223 0.481632 7.482 0.7514C7.75177 1.02117 7.90332 1.38705 7.90332 1.76856C7.90332 2.15007 7.75177 2.51595 7.482 2.78572L7.14288 3.12484M5.10856 1.09051C5.10856 1.09051 5.151 1.81118 5.78679 2.44661C6.42259 3.0824 7.14288 3.12484 7.14288 3.12484M5.10856 1.09051L1.99105 4.2073C1.77997 4.41874 1.67425 4.52446 1.58353 4.64079C1.47648 4.77815 1.38462 4.92668 1.30953 5.0838C1.24624 5.21696 1.19905 5.3589 1.10467 5.64204L0.704462 6.84229M7.14288 3.12484L4.02574 6.24162C3.81466 6.4527 3.70894 6.55842 3.59261 6.64914C3.45525 6.75618 3.30672 6.84805 3.1496 6.92314C3.01644 6.98643 2.87487 7.03362 2.59136 7.128L1.39111 7.52821M0.704462 6.84229L0.606788 7.13532C0.583856 7.2037 0.580454 7.27713 0.596964 7.34735C0.613473 7.41757 0.649241 7.48179 0.700245 7.53279C0.751249 7.58379 0.815468 7.61956 0.885684 7.63607C0.9559 7.65258 1.02933 7.64918 1.09772 7.62625L1.39111 7.52821M0.704462 6.84229L1.39111 7.52821"
        stroke="white"
        strokeWidth="0.548729"
      />
    </svg>
  )
}
